import React, { useState, useEffect } from "react";
import { defer } from "react-router-dom";
import {
  BaseButtons,
  CheckInput,
  TextInputField,
  TextInputFieldArea,
} from "../../../../../../../common-components";
import { Lo8_Alv } from "../../pdf-display-components";
import { colors } from "../../../../../../../../themes/Colors";
import PdfDisplayDoc from "./pdf-display-doc/PdfDisplayDoc";
import JsPDF from "jspdf";

const L25_Doc = ({
  height,
  pdfDisplay,
  setPdfDisplay,
  setLoading,
  setMessage,
  setPopUpTitle,
  setToastPop,
  auth,
  customerData,
  data,
  companyInformation,
}) => {
  //Particulars of owner
  const [request, setRequest] = useState("none");

  const [typeOfIdentification, setTypeOfIdentification] = useState("none");
  const [identificationNumber, setIdentificationNumber] = useState("none");
  const [countryOfIssue, setCountryOfIssue] = useState("none");
  const [surnameNameofOrganisation, setSurnameNameOfOrganisation] =
    useState("none");
  const [intials, setIntials] = useState("none");
  const [FirstName, setFirstName] = useState("none");
  const [emailAddress, setEmailAddress] = useState("none");
  const [tellaphoneNumberAtHome, setTellaphoneNamuberAtHome] = useState("none");
  const [contactTellaphone, setContactTellaphone] = useState("none");
  const [facisimileNumber, setFacisimlieNumber] = useState("none");
  const [cellNumber, setCellNumber] = useState("none");
  const [postalAddress, setPostalAddress] = useState("none");
  const [suburb, setSuburb] = useState("none");
  const [cityTown, setCityTown] = useState("none");
  const [postalCode, setPostalCode] = useState("none");
  const [streetAddress, setStreetAddress] = useState("none");
  const [streetSuburb, setStreetSuburb] = useState("none");
  const [streetCityTown, setStreetCityTown] = useState("none");
  const [postalStreetCode, setPostalStreetCode] = useState("none");
  const [addressForNotices, setAddressForNotices] = useState("none");
  // organistion proxy
  const [organistiontypeOfIdentification, setorganistionTypeOfIdentification] =
    useState("none");
  const [organistionidentificationNumber, setorganistionIdentificationNumber] =
    useState("none");
  const [organistioncountryOfIssue, setorganistionCountryOfIssue] =
    useState("none");
  const [organistionsurname, setorganistionSurnameName] = useState("none");
  const [organistionIntials, setorganistionIntials] = useState("none");
  // organistion representitive
  const [
    representitivetypeOfIdentification,
    setRepresentitiveTypeOfIdentification,
  ] = useState("none");
  const [
    representitiveidentificationNumber,
    setRepresentitiveIdentificationNumber,
  ] = useState("none");
  const [representitivecountryOfIssue, setRepresentitiveCountryOfIssue] =
    useState("none");
  const [representitivesurname, setRepresentitiveSurnameName] =
    useState("none");
  const [representitiveIntials, setRepresentitiveIntials] = useState("none");
  // mptor vehicle indetoification
  const [liscense, setLiscense] = useState("none");
  const [vehicleRegisterNumber, setVehicleRegisterNumber] = useState("none");
  const [chassisNumber, setChassisNumber] = useState("none");
  const [make, setMake] = useState("none");
  const [seriesName, setSeriesName] = useState("none");
  const [odoReading, setOdoReading] = useState("none");
  const [steeringWheelPosition, setSteeringWheeelPosition] = useState("none");

  // auto complete functions
  //   console.log("data", data);
  //   console.log("companyInformation", companyInformation);
  //   console.log("customerData", customerData);

  const VehicleInfoAutoComplete = () => {
    setLiscense(
      !data.vehicleId.liscense ? "not found" : data.vehicleId.liscense
    );
    setVehicleRegisterNumber(data.vehicleId.registerNumber);
    setChassisNumber(data.vehicleId.vehicleIndentificationNumber);
    setMake(data.vehicleId.make);
    setSeriesName(data.vehicleId.series);
    //   setOdoReading(
    //     respnseData.data[Number(respnseData.data.length - 1)].docmentData[0].L08
    //       .odoReading
    //   );
    //   setSteeringWheeelPosition(
    //     respnseData.data[Number(respnseData.data.length - 1)].docmentData[0].L08
    //       .steeringWheelPosition
    //   );
  };
  const VehicleInfoAutoClear = () => {
    setLiscense("");
    setVehicleRegisterNumber("");
    setChassisNumber("");
    setMake("");
    setSeriesName("");
    //   setOdoReading(
    //     respnseData.data[Number(respnseData.data.length - 1)].docmentData[0].L08
    //       .odoReading
    //   );
    //   setSteeringWheeelPosition(
    //     respnseData.data[Number(respnseData.data.length - 1)].docmentData[0].L08
    //       .steeringWheelPosition
    //   );
  };

  const customerPaticularsAutoComplete = () => {
    setTypeOfIdentification("RSA ID");
    setIdentificationNumber(customerData.idNumber);
    setCountryOfIssue("none");
    setSurnameNameOfOrganisation(customerData.lastName);

    setIntials(customerData.firstName.substring(0, 1));
    setFirstName(customerData.firstName);
    setEmailAddress(customerData.email);
    setTellaphoneNamuberAtHome(customerData.landline);
    setContactTellaphone(customerData.cellNumber);
    setFacisimlieNumber(customerData.cellNumber);
    setCellNumber(customerData.cellNumber);
    setPostalAddress(customerData.address);

    setStreetAddress(customerData.address);
    setSuburb("none");
    setCityTown("none");
    setPostalCode("none");
    setStreetSuburb("none");
    setStreetCityTown("none");
    setPostalStreetCode("none");
  };

  const customerPaticularsClear = () => {
    setTypeOfIdentification("");
    setIdentificationNumber("");
    setCountryOfIssue("");
    setSurnameNameOfOrganisation("");

    setIntials("");
    setFirstName("");
    setEmailAddress("");
    setTellaphoneNamuberAtHome("");
    setContactTellaphone("");
    setFacisimlieNumber("");
    setCellNumber("");
    setPostalAddress("");

    setStreetAddress("");
    setSuburb("");
    setCityTown("");
    setPostalCode("");
    setStreetSuburb("");
    setStreetCityTown("");
    setPostalStreetCode("");
  };

  const generatePDF = async () => {
    // prescriptionPdf();
    // setDownloading(true);
    const report = await new JsPDF("portrait", "px", [842, 596]);
    report.html(document.querySelector("#report")).then(() => {
      report.getFontList();

      report.save("report.pdf");
    });
  };
  //   console.log("companyInformation", companyInformation);
  //   console.log("data", data);
  const getTaskDocInfo = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/getAllTaskDocuments",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            taskId: data._id,
            linkedVehicleId: data.vehicleId._id,
            docType: "L25",
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        // let typeOfIden =
        //   respnseData.data[Number(respnseData.data.length - 1)].documentData[0]
        //     .L08.typeOfIdentification;

        setTypeOfIdentification(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.typeOfIdentification
        );
        setIdentificationNumber(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.identificationNumber
        );
        setCountryOfIssue(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.countryOfIssue
        );
        setSurnameNameOfOrganisation(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.surnameNameofOrganisation
        );

        setIntials(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.intials
        );
        setFirstName(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.FirstName
        );
        setEmailAddress(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.emailAddress
        );
        setTellaphoneNamuberAtHome(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.tellaphoneNumberAtHome
        );
        setContactTellaphone(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.contactTellaphone
        );
        setFacisimlieNumber(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.facisimileNumber
        );
        setCellNumber(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.cellNumber
        );
        setPostalAddress(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.postalAddress
        );
        setPostalAddress(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.postalAddress
        );
        setStreetAddress(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.streetAddress
        );
        setSuburb(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.suburb
        );
        setCityTown(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.cityTown
        );
        setPostalCode(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.postalCode
        );
        setStreetSuburb(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.streetSuburb
        );
        setStreetCityTown(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.streetCityTown
        );
        setPostalStreetCode(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.postalStreetCode
        );
        setAddressForNotices(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.addressForNotices
        );
        setorganistionTypeOfIdentification(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.organistiontypeOfIdentification
        );
        setorganistionIdentificationNumber(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.organistionidentificationNumber
        );
        setorganistionCountryOfIssue(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.organistioncountryOfIssue
        );
        setorganistionSurnameName(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.organistionsurname
        );
        setorganistionIntials(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.organistionIntials
        );
        setRepresentitiveTypeOfIdentification(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.representitivetypeOfIdentification
        );
        setRepresentitiveSurnameName(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.representitivesurname
        );
        setRepresentitiveCountryOfIssue(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.representitivecountryOfIssue
        );
        setRepresentitiveIntials(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.representitiveIntials
        );

        setLiscense(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.liscense
        );
        setVehicleRegisterNumber(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.vehicleRegisterNumber
        );
        setChassisNumber(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.chassisNumber
        );
        setMake(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.make
        );
        setSeriesName(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.seriesName
        );
        setOdoReading(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.odoReading
        );
        setSteeringWheeelPosition(
          respnseData.data[Number(respnseData.data.length - 1)].docmentData[0]
            .L25.steeringWheelPosition
        );

        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
    }
  };

  const SaveAndPrint = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/createTaskDocument",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            taskId: data._id,
            createdBy: auth.firstName + " " + auth.lastName,
            user: customerData.firstName + " " + customerData.lastName,

            docCode: "L25",
            linkedVehicleId: data.vehicleId._id,
            linkedUserId: customerData._id,
            linkedAgencyId: companyInformation.companyId,
            linkedAgent: auth.firstName + " " + auth.lastName,
            docmentData: {
              L25: {
                typeOfIdentification: typeOfIdentification,
                identificationNumber: identificationNumber,
                countryOfIssue: countryOfIssue,
                surnameNameofOrganisation: surnameNameofOrganisation,
                intials: intials,
                FirstName: FirstName,
                emailAddress: emailAddress,
                tellaphoneNumberAtHome: tellaphoneNumberAtHome,
                contactTellaphone: contactTellaphone,
                facisimileNumber: facisimileNumber,
                cellNumber: cellNumber,
                postalAddress: postalAddress,
                suburb: suburb,
                cityTown: cityTown,
                postalCode: postalCode,
                streetAddress: streetAddress,
                streetSuburb: streetSuburb,
                streetCityTown: streetCityTown,
                postalStreetCode: postalStreetCode,
                addressForNotices: addressForNotices,
                organistiontypeOfIdentification:
                  organistiontypeOfIdentification,
                organistionidentificationNumber:
                  organistionidentificationNumber,
                organistioncountryOfIssue: organistioncountryOfIssue,
                organistionsurname: organistionsurname,
                organistionIntials: organistionIntials,
                // organistion representitive

                representitivetypeOfIdentification:
                  representitivetypeOfIdentification,

                representitiveidentificationNumber:
                  representitiveidentificationNumber,
                representitivecountryOfIssue: representitivecountryOfIssue,
                representitivesurname: representitivesurname,
                representitiveIntials: representitiveIntials,
                // mptor vehicle indetoification
                liscense: liscense,
                vehicleRegisterNumber: vehicleRegisterNumber,
                chassisNumber: chassisNumber,
                make: make,
                seriesName: seriesName,
                odoReading: odoReading,
                steeringWheelPosition: steeringWheelPosition,
              },
            },
            docType: "L25",
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);
        setPdfDisplay("none");
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage("document created and saved");

        // setToastPop(true);
      } else {
        setLoading(false);
      }
      //  else {
      //   setLoading(false);
      //   setPopUpTitle("FAILED");
      //   setMessage("Unable to find customers, " + " " + respnseData.message);
      //   setToastPop(true);
      // }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      // setMessage(
      //   "Unable to login into account, please wait 5 mins then try again or contact support" +
      //     " " +
      //     err
      // );
      // setToastPop(true);
    }
  };

  //   getAllTaskDocuments
  useEffect(() => {
    getTaskDocInfo();
    // here we need to fetch data and then display it
  }, []);
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        width: "100%",
        backgroundColor: colors.white,
        height: "100%",
        right: 0,
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <div
        style={{
          width: "40%",

          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          position: "relative",
        }}
      >
        <div
          style={{
            fontSize: 18,
            fontWeight: "bold",
            marginTop: 10,
            width: "95%",
            textAlign: "left",
          }}
        >
          DOCUMENT {pdfDisplay.toLocaleUpperCase()}
        </div>
        <div
          style={{
            height: height - 260,

            width: "95%",
            marginTop: 10,
            overflowY: "scroll",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ width: "90%" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: 16,
                marginBottom: 20,
                marginTop: 20,
                position: "relative",
                width: "90%",
                display: "flex",
                alignItems: "center",
              }}
            >
              PATICULARS OF OWNER
              <div
                style={{ position: "absolute", right: -35, display: "flex" }}
              >
                <BaseButtons
                  label={"COMPLETE"}
                  borderRadius={4}
                  backgroundColor={colors.greenDark}
                  onClick={() => customerPaticularsAutoComplete()}
                />
                <div style={{ minWidth: 20 }} />
                <BaseButtons
                  label={"CLEAR"}
                  borderRadius={4}
                  backgroundColor={colors.greenDark}
                  onClick={() => customerPaticularsClear()}
                />
              </div>
            </div>
            <div
              style={{ fontWeight: "bold", marginBottom: 10, marginTop: 10 }}
            >
              Type of identification
            </div>
            <CheckInput
              selected={
                typeOfIdentification === "traffic register number"
                  ? true
                  : false
              }
              label={"traffic register number"}
              onClick={() =>
                setTypeOfIdentification(
                  typeOfIdentification === "traffic register number"
                    ? "none"
                    : "traffic register number"
                )
              }
            />
            <CheckInput
              selected={typeOfIdentification === "RSA ID" ? true : false}
              label={"RSA ID"}
              onClick={() =>
                setTypeOfIdentification(
                  typeOfIdentification === "RSA ID" ? "none" : "RSA ID"
                )
              }
            />
            <CheckInput
              selected={typeOfIdentification === "FOREIGN ID" ? true : false}
              label={"FOREIGN ID"}
              onClick={() =>
                setTypeOfIdentification(
                  typeOfIdentification === "FOREIGN ID" ? "none" : "FOREIGN ID"
                )
              }
            />
            <CheckInput
              selected={
                typeOfIdentification === "BUSINESS REG NO" ? true : false
              }
              label={"BUSINESS REG NO"}
              onClick={() =>
                setTypeOfIdentification(
                  typeOfIdentification === "BUSINESS REG NO"
                    ? "none"
                    : "BUSINESS REG NO"
                )
              }
            />

            <TextInputField
              mini={true}
              labelTitle={"Identification number"}
              value={identificationNumber}
              onChange={(e) => setIdentificationNumber(e.target.value)}
              size={"90%"}
            />
            {typeOfIdentification === "FOREIGN ID" ? (
              <TextInputField
                mini={true}
                labelTitle={"Country of issue if foreign id"}
                value={countryOfIssue}
                onChange={(e) => setCountryOfIssue(e.target.value)}
                size={"90%"}
              />
            ) : null}

            <TextInputField
              mini={true}
              labelTitle={"surname / Name of organisation"}
              value={surnameNameofOrganisation}
              onChange={(e) => setSurnameNameOfOrganisation(e.target.value)}
              size={"90%"}
            />

            <TextInputField
              mini={true}
              labelTitle={"Intials (no more than 3)"}
              value={intials}
              onChange={(e) => setIntials(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"first names"}
              value={FirstName}
              onChange={(e) => setFirstName(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Email address"}
              value={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Telaphone number at home"}
              value={tellaphoneNumberAtHome}
              onChange={(e) => setTellaphoneNamuberAtHome(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Contact number during the day"}
              value={contactTellaphone}
              onChange={(e) => setContactTellaphone(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Facsimile number"}
              value={facisimileNumber}
              onChange={(e) => setFacisimlieNumber(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Cellphone number"}
              value={cellNumber}
              onChange={(e) => setCellNumber(e.target.value)}
              size={"90%"}
            />
            <TextInputFieldArea
              mini={true}
              labelTitle={"Postal address"}
              value={postalAddress}
              onChange={(e) => setPostalAddress(e.target.value)}
              size={"90%"}
              height={80}
            />
            <TextInputField
              mini={true}
              labelTitle={"Suburb"}
              value={suburb}
              onChange={(e) => setSuburb(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"City / Town"}
              value={cityTown}
              onChange={(e) => setCityTown(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Postal code"}
              value={postalCode}
              onChange={(e) => setPostalCode(e.target.value)}
              size={"90%"}
            />
            <TextInputFieldArea
              mini={true}
              labelTitle={"Street address"}
              value={streetAddress}
              onChange={(e) => setStreetAddress(e.target.value)}
              size={"90%"}
              height={80}
            />
            <TextInputField
              mini={true}
              labelTitle={"Suburb"}
              value={streetSuburb}
              onChange={(e) => setStreetSuburb(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"City / Town"}
              value={streetCityTown}
              onChange={(e) => setStreetCityTown(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Postal code"}
              value={postalStreetCode}
              onChange={(e) => setPostalStreetCode(e.target.value)}
              size={"90%"}
            />
            <div
              style={{ fontWeight: "bold", marginBottom: 10, marginTop: 10 }}
            >
              Address for notices
            </div>
            <CheckInput
              selected={addressForNotices === "Postal" ? true : false}
              label={"Postal Address"}
              onClick={() =>
                setAddressForNotices(
                  addressForNotices === "Postal" ? "none" : "Postal"
                )
              }
            />
            <CheckInput
              selected={addressForNotices === "Street" ? true : false}
              label={"Street Address"}
              onClick={() =>
                setAddressForNotices(
                  addressForNotices === "Street" ? "none" : "Street"
                )
              }
            />
            <div
              style={{
                fontWeight: "bold",
                fontSize: 20,
                marginBottom: 10,
                marginTop: 30,
              }}
            >
              ORGANISATION'S PROXY
            </div>
            <div
              style={{ fontWeight: "bold", marginBottom: 10, marginTop: 10 }}
            >
              Type of identification
            </div>
            <CheckInput
              selected={
                organistiontypeOfIdentification === "traffic register number"
                  ? true
                  : false
              }
              label={"traffic register number"}
              onClick={() =>
                setorganistionTypeOfIdentification(
                  organistiontypeOfIdentification === "traffic register number"
                    ? "none"
                    : "traffic register number"
                )
              }
            />
            <CheckInput
              selected={
                organistiontypeOfIdentification === "RSA ID" ? true : false
              }
              label={"RSA ID"}
              onClick={() =>
                setorganistionTypeOfIdentification(
                  organistiontypeOfIdentification === "RSA ID"
                    ? "none"
                    : "RSA ID"
                )
              }
            />
            <CheckInput
              selected={
                organistiontypeOfIdentification === "FOREIGN ID" ? true : false
              }
              label={"FOREIGN ID"}
              onClick={() =>
                setorganistionTypeOfIdentification(
                  organistiontypeOfIdentification === "FOREIGN ID"
                    ? "none"
                    : "FOREIGN ID"
                )
              }
            />

            <TextInputField
              mini={true}
              labelTitle={"Identification number"}
              value={organistionidentificationNumber}
              onChange={(e) =>
                setorganistionIdentificationNumber(e.target.value)
              }
              size={"90%"}
            />
            {organistiontypeOfIdentification === "FOREIGN ID" ? (
              <TextInputField
                mini={true}
                labelTitle={"Country of issue if foreign id"}
                value={organistioncountryOfIssue}
                onChange={(e) => setorganistionCountryOfIssue(e.target.value)}
                size={"90%"}
              />
            ) : null}

            <TextInputField
              mini={true}
              labelTitle={"Surname"}
              value={organistionsurname}
              onChange={(e) => setorganistionSurnameName(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Intials"}
              value={organistionIntials}
              onChange={(e) => setorganistionIntials(e.target.value)}
              size={"90%"}
            />
            <div
              style={{
                fontWeight: "bold",
                fontSize: 20,
                marginBottom: 10,
                marginTop: 30,
              }}
            >
              ORGANISATION'S REPRESENTITIVE
            </div>
            <div
              style={{ fontWeight: "bold", marginBottom: 10, marginTop: 10 }}
            >
              Type of identification
            </div>
            <CheckInput
              selected={
                representitivetypeOfIdentification === "traffic register number"
                  ? true
                  : false
              }
              label={"traffic register number"}
              onClick={() =>
                setRepresentitiveTypeOfIdentification(
                  representitivetypeOfIdentification ===
                    "traffic register number"
                    ? "none"
                    : "traffic register number"
                )
              }
            />
            <CheckInput
              selected={
                representitivetypeOfIdentification === "RSA ID" ? true : false
              }
              label={"RSA ID"}
              onClick={() =>
                setRepresentitiveTypeOfIdentification(
                  representitivetypeOfIdentification === "RSA ID"
                    ? "none"
                    : "RSA ID"
                )
              }
            />
            <CheckInput
              selected={
                representitivetypeOfIdentification === "FOREIGN ID"
                  ? true
                  : false
              }
              label={"FOREIGN ID"}
              onClick={() =>
                setRepresentitiveTypeOfIdentification(
                  representitivetypeOfIdentification === "FOREIGN ID"
                    ? "none"
                    : "FOREIGN ID"
                )
              }
            />

            <TextInputField
              mini={true}
              labelTitle={"Identification number"}
              value={representitiveidentificationNumber}
              onChange={(e) =>
                setRepresentitiveIdentificationNumber(e.target.value)
              }
              size={"90%"}
            />
            {representitivetypeOfIdentification === "FOREIGN ID" ? (
              <TextInputField
                mini={true}
                labelTitle={"Country of issue if foreign id"}
                value={representitivecountryOfIssue}
                onChange={(e) =>
                  setRepresentitiveCountryOfIssue(e.target.value)
                }
                size={"90%"}
              />
            ) : null}

            <TextInputField
              mini={true}
              labelTitle={"Surname"}
              value={representitivesurname}
              onChange={(e) => setRepresentitiveSurnameName(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Intials"}
              value={representitiveIntials}
              onChange={(e) => setRepresentitiveIntials(e.target.value)}
              size={"90%"}
            />
            <div
              style={{
                fontWeight: "bold",
                fontSize: 16,
                marginBottom: 10,
                marginTop: 30,
                position: "relative",
                width: "90%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ width: 200 }}>INDENTIFICATION OF MOTOR VEHICLE</div>

              <div
                style={{ position: "absolute", right: -35, display: "flex" }}
              >
                <BaseButtons
                  label={"COMPLETE"}
                  borderRadius={4}
                  backgroundColor={colors.greenDark}
                  onClick={() => VehicleInfoAutoComplete()}
                />
                <div style={{ minWidth: 20 }} />
                <BaseButtons
                  label={"CLEAR"}
                  borderRadius={4}
                  backgroundColor={colors.greenDark}
                  onClick={() => VehicleInfoAutoClear()}
                />
              </div>
            </div>
            <TextInputField
              mini={true}
              labelTitle={"Liscense number"}
              value={liscense}
              onChange={(e) => setLiscense(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Vehicle registraion number"}
              value={vehicleRegisterNumber}
              onChange={(e) => setVehicleRegisterNumber(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Chassis number"}
              value={chassisNumber}
              onChange={(e) => setChassisNumber(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Make"}
              value={make}
              onChange={(e) => setMake(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Series name"}
              value={seriesName}
              onChange={(e) => setSeriesName(e.target.value)}
              size={"90%"}
            />
            <TextInputField
              mini={true}
              labelTitle={"Odo reading"}
              value={odoReading}
              onChange={(e) => setOdoReading(e.target.value)}
              size={"90%"}
            />
            <div
              style={{ fontWeight: "bold", marginBottom: 10, marginTop: 10 }}
            >
              Steering wheel position
            </div>
            <CheckInput
              selected={steeringWheelPosition === "Drawn" ? true : false}
              label={"Drawn"}
              onClick={() =>
                setSteeringWheeelPosition(
                  steeringWheelPosition === "Drawn" ? "none" : "Drawn"
                )
              }
            />
            <CheckInput
              selected={steeringWheelPosition === "Left" ? true : false}
              label={"Left"}
              onClick={() =>
                setSteeringWheeelPosition(
                  steeringWheelPosition === "Left" ? "none" : "Left"
                )
              }
            />
            <CheckInput
              selected={steeringWheelPosition === "Center" ? true : false}
              label={"Center"}
              onClick={() =>
                setSteeringWheeelPosition(
                  steeringWheelPosition === "none" ? "none" : "Center"
                )
              }
            />
            <CheckInput
              selected={steeringWheelPosition === "Right" ? true : false}
              label={"Right"}
              onClick={() =>
                setSteeringWheeelPosition(
                  steeringWheelPosition === "Right" ? "none" : "Right"
                )
              }
            />
            <div style={{ minHeight: 20 }} />
          </div>
        </div>
        <div
          style={{
            width: "100%",
            position: "absolute",
            bottom: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <BaseButtons
            onClick={() => {
              SaveAndPrint();
            }}
            label={"SAVE DATA"}
            width={"95%"}
            backgroundColor={colors.greenLight}
          />
          <div style={{ minHeight: 5 }} />
          <BaseButtons
            onClick={() => {
              generatePDF();
              SaveAndPrint();
            }}
            label={"PRINT COMPLETED DOC"}
            width={"95%"}
            backgroundColor={colors.secondaryDarkBlue}
          />
          <div style={{ minHeight: 5 }} />
          <BaseButtons
            onClick={() => setPdfDisplay("none")}
            label={"CLOSE"}
            width={"95%"}
            backgroundColor={colors.orangeDark}
          />
        </div>
      </div>
      <div
        id="report"
        style={{
          fontFamily: "Arial",
          width: "60%",
          //   height: height - 60,
          overflowY: "scroll",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          maxWidth: 700,
          minWidth: 596,
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            // width: "100%",
          }}
        >
          <PdfDisplayDoc
            height={842}
            // width={"100%"}
            width={596}
            title={"L25_MVR_PAGE_1"}
            image={require("../../../liscenseDocPng/L25_MVR1_MIB_page1.png")}
          />
          {/* // this is indetifcation type */}
          <div
            style={{
              position: "absolute",
              width: 245,
              //   borderStyle: "solid",
              top: 199,
              minHeight: 18,

              maxHeight: 18,
              display: "flex",
            }}
          >
            {typeOfIdentification === "traffic register number" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,

                  flex: 0.32,

                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,

                  flex: 0.32,

                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {typeOfIdentification === "RSA ID" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.145,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.145,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {typeOfIdentification === "FOREIGN ID" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.25,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.25,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {typeOfIdentification === "BUSINESS REG NO" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.29,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.29,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
          </div>
          {/* idetification number  */}
          <div
            style={{
              position: "absolute",
              width: 165,
              //   borderStyle: "solid",
              top: 228,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              //   borderWidth: 0.5,
              textAlign: "center",
              borderWidth: 0.5,
              borderStyle: "solid",
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {identificationNumber.toLocaleUpperCase()}
          </div>
          {/* country of issue */}
          <div
            style={{
              position: "absolute",
              width: 349,
              //   borderStyle: "solid",
              top: 248,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              //   borderWidth: 0.5,
              textAlign: "center",
              marginLeft: 2,
              borderWidth: 0.5,
              borderStyle: "solid",
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {countryOfIssue.toLocaleUpperCase()}
          </div>
          {/* surname or organistation name */}
          <div
            style={{
              position: "absolute",
              width: 411,
              //   borderStyle: "solid",
              top: 270,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              //   borderWidth: 0.5,
              textAlign: "center",
              marginLeft: 6,
              borderWidth: 0.5,
              borderStyle: "solid",
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {surnameNameofOrganisation.toLocaleUpperCase()}
          </div>
          {/* intials */}
          <div
            style={{
              position: "absolute",
              width: 40,
              //   borderStyle: "solid",
              top: 293,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              //   borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 8,
              left: 138,
              justifyContent: "space-evenly",
              borderWidth: 0.5,
              borderStyle: "solid",
              letterSpacing: 1,
              //   paddingLeft: 3,
            }}
          >
            {intials.toLocaleUpperCase()}
          </div>
          {/* firstname */}
          <div
            style={{
              position: "absolute",
              width: 256,
              //   borderStyle: "solid",
              top: 293,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              //   borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 8,
              left: 210,
              borderWidth: 0.5,
              borderStyle: "solid",
              letterSpacing: 1,
              paddingLeft: 3,
              //   justifyContent: "space-evenly",
            }}
          >
            {FirstName.toLocaleUpperCase()}
          </div>
          {/* email address */}
          <div
            style={{
              position: "absolute",
              width: 396,
              //   borderStyle: "solid",
              top: 319,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              //   borderWidth: 0.5,
              textAlign: "center",
              marginLeft: 11,
              borderWidth: 0.5,
              borderStyle: "solid",
              letterSpacing: 1,
              paddingLeft: 3,
              //   left: 210,
              //   justifyContent: "space-evenly",
            }}
          >
            {emailAddress.toLocaleUpperCase()}
          </div>
          {/* telephone */}
          <div
            style={{
              position: "absolute",
              width: 178,
              //   borderStyle: "solid",
              top: 339,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              //   borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 12,
              left: 203,
              borderWidth: 0.5,
              borderStyle: "solid",
              letterSpacing: 1,
              paddingLeft: 3,
              //   justifyContent: "space-evenly",
            }}
          >
            <div>{tellaphoneNumberAtHome.toLocaleUpperCase()}</div>
          </div>
          {/* contact number */}
          <div
            style={{
              position: "absolute",
              width: 178,
              //   borderStyle: "solid",
              top: 371,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              //   borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 12,
              left: 203,
              borderWidth: 0.5,
              borderStyle: "solid",
              letterSpacing: 1,
              paddingLeft: 3,
              //   justifyContent: "space-evenly",
            }}
          >
            <div>{contactTellaphone.toLocaleUpperCase()}</div>
          </div>
          {/* facisimelie number */}
          <div
            style={{
              position: "absolute",
              width: 178,

              top: 403,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",

              textAlign: "center",
              //   marginLeft: 12,
              left: 203,
              borderWidth: 0.5,
              borderStyle: "solid",
              letterSpacing: 1,
              paddingLeft: 3,
              //   justifyContent: "space-evenly",
            }}
          >
            <div>{facisimileNumber.toLocaleUpperCase()}</div>
          </div>
          {/* cell number */}
          <div
            style={{
              position: "absolute",
              width: 138,
              borderStyle: "solid",
              top: 435,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 12,
              left: 228,
              letterSpacing: 1,
              paddingLeft: 3,
              //   justifyContent: "space-evenly",
            }}
          >
            <div>{cellNumber.toLocaleUpperCase()}</div>
          </div>
          {/* //postal address group */}
          <>
            <div
              style={{
                position: "absolute",
                width: 380,
                borderStyle: "solid",
                top: 455,
                minHeight: 40,
                maxHeight: 40,
                display: "flex",
                fontSize: 12,
                backgroundColor: "#FFFFFF",
                borderWidth: 0.5,
                textAlign: "center",
                //   marginLeft: 12,
                left: 108,
                //   justifyContent: "space-evenly",
                textAlign: "left",
                letterSpacing: 1,
                paddingLeft: 3,
              }}
            >
              {postalAddress.toLocaleUpperCase()}
            </div>
            <div
              style={{
                position: "absolute",
                width: 318,
                borderStyle: "solid",
                top: 496,
                minHeight: 15,
                maxHeight: 15,
                display: "flex",
                fontSize: 12,
                backgroundColor: "#FFFFFF",
                borderWidth: 0.5,
                textAlign: "center",
                //   marginLeft: 12,
                left: 108,
                //   justifyContent: "space-evenly",
                textAlign: "left",
                letterSpacing: 1,
                paddingLeft: 3,
              }}
            >
              {suburb.toLocaleUpperCase()}
            </div>
            <div
              style={{
                position: "absolute",
                width: 318,
                borderStyle: "solid",
                top: 512,
                minHeight: 15,
                maxHeight: 15,
                display: "flex",
                fontSize: 12,
                backgroundColor: "#FFFFFF",
                borderWidth: 0.5,
                textAlign: "center",
                //   marginLeft: 12,
                left: 108,
                //   justifyContent: "space-evenly",
                textAlign: "left",
                letterSpacing: 1,
                paddingLeft: 3,
              }}
            >
              {cityTown.toLocaleUpperCase()}
            </div>
            <div
              style={{
                position: "absolute",
                width: 53,
                borderStyle: "solid",
                top: 512,
                minHeight: 15,
                maxHeight: 15,
                display: "flex",
                fontSize: 12,
                backgroundColor: "#FFFFFF",
                borderWidth: 0.5,
                textAlign: "center",
                //   marginLeft: 12,
                left: 439,
                //   justifyContent: "space-evenly",
                textAlign: "left",
                letterSpacing: 1,
              }}
            >
              {postalCode.toLocaleUpperCase()}
            </div>
          </>
          {/* //street address group */}
          <>
            <div
              style={{
                position: "absolute",
                width: 380,
                borderStyle: "solid",
                top: 537,
                minHeight: 41,
                maxHeight: 41,
                display: "flex",
                fontSize: 12,
                backgroundColor: "#FFFFFF",
                borderWidth: 0.5,
                textAlign: "center",
                //   marginLeft: 12,
                left: 108,
                //   justifyContent: "space-evenly",
                textAlign: "left",
                letterSpacing: 1,
                paddingLeft: 3,
              }}
            >
              {streetAddress.toLocaleUpperCase()}
            </div>
            <div
              style={{
                position: "absolute",
                width: 318,
                borderStyle: "solid",
                top: 579,
                minHeight: 15,
                maxHeight: 15,
                display: "flex",
                fontSize: 12,
                backgroundColor: "#FFFFFF",
                borderWidth: 0.5,
                textAlign: "center",
                //   marginLeft: 12,
                left: 108,
                //   justifyContent: "space-evenly",
                textAlign: "left",
                letterSpacing: 1,
                paddingLeft: 3,
              }}
            >
              {streetSuburb.toLocaleUpperCase()}
            </div>
            <div
              style={{
                position: "absolute",
                width: 318,
                borderStyle: "solid",
                top: 594,
                minHeight: 15,
                maxHeight: 15,
                display: "flex",
                fontSize: 12,
                backgroundColor: "#FFFFFF",
                borderWidth: 0.5,
                textAlign: "center",
                //   marginLeft: 12,
                left: 108,
                //   justifyContent: "space-evenly",
                textAlign: "left",
                letterSpacing: 1,
                paddingLeft: 3,
              }}
            >
              {streetCityTown.toLocaleUpperCase()}
            </div>
            <div
              style={{
                position: "absolute",
                width: 50,
                borderStyle: "solid",
                top: 594,
                minHeight: 15,
                maxHeight: 15,
                display: "flex",
                fontSize: 12,
                backgroundColor: "#FFFFFF",
                borderWidth: 0.5,
                textAlign: "center",
                //   marginLeft: 12,
                left: 439,
                //   justifyContent: "space-evenly",
                textAlign: "left",
                letterSpacing: 1,
                paddingLeft: 3,
              }}
            >
              {postalStreetCode.toLocaleUpperCase()}
            </div>
          </>
          {/* // this is indetifcation type */}
          <div
            style={{
              position: "absolute",
              width: 136,
              //   borderStyle: "solid",
              borderWidth: 0.5,
              top: 617,
              minHeight: 22,

              maxHeight: 22,
              display: "flex",
              marginRight: 0.5,
            }}
          >
            {addressForNotices === "Postal" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.5,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.5,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {addressForNotices === "Street" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.5,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.5,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
          </div>

          {/* // this is the orgnasation proxy  */}
          {/* // this is indetifcation type */}
          <div
            style={{
              position: "absolute",
              width: 165,
              //   borderStyle: "solid",
              //   borderWidth: 0.5,
              top: 684,
              minHeight: 20,

              maxHeight: 20,
              display: "flex",
            }}
          >
            {organistiontypeOfIdentification === "traffic register number" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,

                  flex: 0.45,

                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,

                  flex: 0.45,

                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {organistiontypeOfIdentification === "RSA ID" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.2,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.2,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {organistiontypeOfIdentification === "FOREIGN ID" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.35,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.35,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
          </div>
          {/* idetification number  */}
          <div
            style={{
              position: "absolute",
              width: 164,
              borderStyle: "solid",
              top: 712,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {organistionidentificationNumber.toLocaleUpperCase()}
          </div>
          {/* country of issue */}
          <div
            style={{
              position: "absolute",
              width: 354.5,
              borderStyle: "solid",
              top: 732,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              marginLeft: 4,
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {organistioncountryOfIssue.toLocaleUpperCase()}
          </div>
          {/* surname or organistation name */}
          <div
            style={{
              position: "absolute",
              width: 342,
              borderStyle: "solid",
              top: 752,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 8,
              left: 96,
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {organistionsurname.toLocaleUpperCase()}
          </div>
          {/* intials */}
          <div
            style={{
              position: "absolute",
              width: 40,
              borderStyle: "solid",
              top: 752,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 8,
              left: 466,
              justifyContent: "space-evenly",
              letterSpacing: 1,
              //   paddingLeft: 3,
            }}
          >
            {organistionIntials.toLocaleUpperCase()}
          </div>
        </div>
        <div
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <PdfDisplayDoc
            height={842}
            // width={"100%"}
            width={596}
            title={"L25_MVR_PAGE_2"}
            image={require("../../../liscenseDocPng/L25_MVR1_MIB_page2.png")}
          />
          {/* // this is the orgnasation representitive  */}
          {/* // this is indetifcation type */}
          <div
            style={{
              position: "absolute",
              width: 165,
              //   borderStyle: "solid",
              //   borderWidth: 0.5,
              top: 52,
              minHeight: 20,

              maxHeight: 20,
              display: "flex",
            }}
          >
            {representitivetypeOfIdentification ===
            "traffic register number" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,

                  flex: 0.45,

                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,

                  flex: 0.45,

                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {representitivetypeOfIdentification === "RSA ID" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.2,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.2,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {representitivetypeOfIdentification === "FOREIGN ID" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.35,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.35,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
          </div>
          {/* idetification number  */}
          <div
            style={{
              position: "absolute",
              width: 166,
              borderStyle: "solid",
              top: 82,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {representitiveidentificationNumber.toLocaleUpperCase()}
          </div>
          {/* country of issue */}
          <div
            style={{
              position: "absolute",
              width: 356,
              borderStyle: "solid",
              top: 105,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              marginLeft: 5,
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {representitivecountryOfIssue.toLocaleUpperCase()}
          </div>
          {/* surname or organistation name */}
          <div
            style={{
              position: "absolute",
              width: 343,
              borderStyle: "solid",
              top: 128,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 8,
              left: 96,
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {representitivesurname.toLocaleUpperCase()}
          </div>
          {/* intials */}
          <div
            style={{
              position: "absolute",
              width: 40,
              borderStyle: "solid",
              top: 128,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 8,
              left: 466,
              justifyContent: "space-evenly",
              letterSpacing: 1,
            }}
          >
            {representitiveIntials.toLocaleUpperCase()}
          </div>

          {/* here this will be for vehicle details */}

          {/* liscense number  */}
          <div
            style={{
              position: "absolute",
              width: 113,
              borderStyle: "solid",
              top: 186,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              marginLeft: 1,
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {liscense.toLocaleUpperCase()}
          </div>
          {/* vehicle registration */}
          <div
            style={{
              position: "absolute",
              width: 94,
              borderStyle: "solid",
              top: 209,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              marginLeft: 5,
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {vehicleRegisterNumber.toLocaleUpperCase()}
          </div>
          {/* chassis*/}
          <div
            style={{
              position: "absolute",
              width: 216,
              borderStyle: "solid",
              top: 232,
              minHeight: 16,
              marginLeft: 5,
              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 8,
              //   left: 96,
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {chassisNumber.toLocaleUpperCase()}
          </div>
          {/* make */}
          <div
            style={{
              position: "absolute",
              width: 385,
              borderStyle: "solid",
              top: 255,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 8,
              //   left: 466,
              justifyContent: "space-evenly",
              letterSpacing: 1,
            }}
          >
            {make.toLocaleUpperCase()}
          </div>
          {/* series */}
          <div
            style={{
              position: "absolute",
              width: 385,
              borderStyle: "solid",
              top: 278,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 8,
              //   left: 466,
              justifyContent: "space-evenly",
              letterSpacing: 1,
              //   paddingLeft: 3,
            }}
          >
            {seriesName.toLocaleUpperCase()}
          </div>
          {/* odoreading */}
          <div
            style={{
              position: "absolute",
              width: 72,
              borderStyle: "solid",
              top: 301,
              minHeight: 16,

              maxHeight: 16,
              display: "flex",
              fontSize: 12,
              backgroundColor: "#FFFFFF",
              borderWidth: 0.5,
              textAlign: "center",
              //   marginLeft: 8,
              left: 287,
              justifyContent: "left",
              letterSpacing: 1,
              paddingLeft: 3,
            }}
          >
            {odoReading.toLocaleUpperCase()}
          </div>
          {/* // steering wheel */}
          <div
            style={{
              position: "absolute",
              width: 136,
              //   borderStyle: "solid",
              //   borderWidth: 0.5,
              top: 335,
              minHeight: 21,

              maxHeight: 21,
              display: "flex",
              marginRight: 19,
            }}
          >
            {steeringWheelPosition === "Drawn" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,

                  flex: 0.25,

                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,

                  flex: 0.25,

                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {steeringWheelPosition === "Left" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.25,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.25,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {steeringWheelPosition === "Center" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.25,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.25,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
            {steeringWheelPosition === "Right" ? (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.25,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                X
              </div>
            ) : (
              <div
                style={{
                  color: "#000000",
                  fontSize: 20,
                  flex: 0.25,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              ></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default L25_Doc;
